import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';

export const sortAttributes = (eventCodeInfo: EventDetailInfo) => {
    return {
        ...eventCodeInfo,
        attributes: [...eventCodeInfo.attributes].sort((a, b) => {
            if (a.deprecated === b.deprecated) {
                return a.name.localeCompare(b.name);
            }

            return a.deprecated ? 1 : -1;
        }),
    };
};
